import type { Value } from '@skop-app/lib-domain/types'
import { Combobox } from '@/components/molecules/Combobox'
import { useGridState, useGridViews } from './GridRoot'
import type { ExternalFilters, GridExternalFilterProps } from '../types'

type NextValues = Value[] | ((prev: Value[]) => Value[])

export function GridExternalFilter({
  field,
  label,
  options,
  groupOptions,
  placeholder,
  empty,
  listType = 'checkbox',
  triggerType = 'button',
  disabled,
  className,
}: GridExternalFilterProps) {
  const { externalFiltersSelected, setExternalFiltersSelected } = useGridState()
  const views = useGridViews()

  const values = externalFiltersSelected[field] ?? []
  const isDisabled = disabled || views?.isInteractionBlocked === true

  const setValues = (next: NextValues) => {
    const current = externalFiltersSelected[field] ?? []
    const resolved = typeof next === 'function' ? next(current) : next
    const nextFilters: ExternalFilters = { ...externalFiltersSelected }
    if (resolved.length === 0) {
      delete nextFilters[field]
    } else {
      nextFilters[field] = resolved
    }
    setExternalFiltersSelected(nextFilters)
    views?.notifyUserGridViewChange({ externalFilters: nextFilters })
  }

  return (
    <div className={className}>
      <Combobox
        field={field}
        label={label}
        options={options}
        groupOptions={groupOptions}
        values={values}
        setValues={setValues}
        listType={listType}
        triggerType={triggerType}
        placeholder={placeholder}
        empty={empty}
        disabled={isDisabled}
        multiple
      />
    </div>
  )
}
